// extracted by mini-css-extract-plugin
var _1 = "ra-scroll-top-btn-active";
var _2 = "ra-scroll-top-btn";
var _3 = "ra-scroll-top-btn-container";
var _4 = "ra-scroll-top-btn-fixed";
var _5 = "81px";
export { _1 as "scrollTopActiveBtnCls", _2 as "scrollTopBtnCls", _3 as "scrollTopBtnContainerCls", _4 as "scrollTopFixedBtnCls", _5 as "totalButtonOffset" }
